var _require = require('@frameio/vapor'),
    theme = _require.theme;

exports.colors = {
  primary: theme.colors.palette.brandPrimary,
  primaryLight: theme.colors.palette.brandLight,
  primaryDark: theme.colors.palette.brandDark,
  secondary: theme.colors.palette.tintOrange,
  background: theme.colors.palette.tintA90,
  background2: theme.colors.palette.tintA70,
  divider: theme.colors.palette.tintA70,
  tertiary: theme.colors.palette.tintTeal,
  text1: theme.colors.palette.grey30,
  text2: theme.colors.palette.grey40,
  text3: theme.colors.palette.grey50,
  text4: theme.colors.palette.grey60,
  warning: theme.colors.palette.alertWarning,
  hoverOpacity: 0.8
};